/**
 * Here is a two separated parts of original script with purposes:
 * - to setup analytical object for faster access
 * - to load a script
 *
 * Setup fb object but not load the script
 */
export const setup = options => {
  const f = window;

  if (f.fbq) return;
  const n = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];

  if (options.manualMode) {
    window.fbq('set', 'autoConfig', false, options.id);
  }

  window.fbq('init', options.id);
  window.fbq('track', 'PageView');

  window._fbq = window.fbq;
  return window.fbq;
};

/**
 * Load the script
 */
export const load = (options, onLoad, onError) => {
  const b = document;
  const e = 'script';

  const t = b.createElement(e);
  t.async = true;
  t.defer = true;
  if (onLoad) {
    t.onload = t.onreadystatechange = onLoad;
    t.onabort = onError || onLoad;
    t.onerror = onError || onLoad;
  }
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = b.getElementsByTagName('body')[0];
  s.parentNode.appendChild(t, s);
};

/**
 * Some property of loaded script for bulletproof checking
 */
export const isInitialized = (options, waitInterval = 30) => {
  // https://github.com/adopted-ember-addons/ember-metrics/blob/master/tests/unit/metrics-adapters/facebook-pixel-test.js#L7
  return new Promise(resolve => {
    (function wait() {
      window.fbq?.instance?.configsLoaded[options.id]
        ? resolve()
        : setTimeout(() => {
            wait();
          }, waitInterval);
    })();
  });
};
